module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.7-107.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.3.7.md
// module id = 523
// module chunks = 299